import { FC } from "react";

import { useInsight } from "@insights";

/**
 * Insight header factory
 * @constructor
 */
export const InsightHeader: FC = () => {
  const { getComponents } = useInsight();
  const HeaderComponent = getComponents().Header;

  return <HeaderComponent />;
};
